import { Typography } from 'components/typography';
import { CalculatedQuote } from 'lib/api/getLaneHistory';
import { Maybe } from 'types/UtilityTypes';
import { formatCurrency } from 'utils/formatCurrency';

type LaneHistoryMarginSummaryProps = {
  calculatedQuote: Maybe<CalculatedQuote>;
};

export function LaneHistoryMarginSummary({
  calculatedQuote,
}: LaneHistoryMarginSummaryProps) {
  if (!calculatedQuote) {
    return null;
  }

  const { avgSell, avgMargin } = calculatedQuote;
  if (avgSell == null && avgMargin == null) {
    return null;
  }

  const parts: string[] = [];
  if (avgSell != null) {
    parts.push(`Avg sell ${formatCurrency(avgSell, 'USD')}`);
  }
  if (avgMargin != null) {
    parts.push(`Avg margin ${formatCurrency(avgMargin, 'USD')}`);
  }

  return (
    <Typography
      variant='body-xs'
      className='text-neutral-600 text-center mt-2 mb-1'
    >
      {parts.join(' · ')}
    </Typography>
  );
}
